import DoneIcon from '@material-ui/icons/Done';
import EditIcon from '@material-ui/icons/Edit';
import UndoIcon from '@material-ui/icons/Undo';
import React from 'react';
import { useTranslator } from '~frontend-common/i18n/translator';
import { TextInputAction } from '~ui-kit/components/text-input';

interface EditActionsProps {
  onEdit: () => void;
  onUndo?: () => void;
  onConfirm?: () => void;
  isEditing?: boolean;
  isLoading?: boolean;
  canConfirm?: boolean;
  inplaceEdit?: boolean;
  // name used to identify each action button (useful for GA4)
  name?: string;
}

export function EditActions({
  isEditing = false,
  inplaceEdit = true,
  canConfirm = true,
  isLoading,
  name,
  onEdit,
  onUndo,
  onConfirm,
}: EditActionsProps) {
  const { tl } = useTranslator();

  if (isEditing && inplaceEdit) {
    return (
      <>
        <TextInputAction
          data-id={`btn-undo-${name}`}
          key="undo"
          icon={<UndoIcon />}
          onClick={onUndo}
          disabled={isLoading}
          tooltip={tl('profile.undoEdit')}
        />
        <TextInputAction
          data-id={`btn-submit-${name}`}
          key="confirm"
          type="submit"
          icon={<DoneIcon />}
          onClick={onConfirm}
          disabled={!canConfirm || isLoading}
          isLoading={isLoading}
          tooltip={tl('profile.confirmEdit')}
          color="primary"
        />
      </>
    );
  } else {
    return (
      <TextInputAction
        data-id={`btn-edit-${name}`}
        key="edit"
        icon={<EditIcon />}
        onClick={onEdit}
        tooltip={tl('profile.editTooltip')}
      />
    );
  }
}
